<template>
  <div class="update-wrap">

  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  export default {
    name: "update-wrap",
    data () {
      return {}
    },
  }
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/home/mine/update/index.vue